<form>
  <formly-form
    [form]="form"
    [fields]="(formlyFormConfig | async).fields"
    [options]="options"
    [model]="formModel"
  ></formly-form>
</form>
